import type { Environment } from './environment.types';

export const environment: Environment = {
  cws: '/api',
  directusUrl: 'https://training.cms.digital-catalog.cws.otosrl.com',
  name: 'preview',
  production: false,
};
